// Named SFX presets. Each function takes an AudioContext + output node
// and schedules a short sound. Call sites use these names so the SFX can
// be swapped for loaded samples later without touching gameplay code.
//
// Catalog (acceptance criterion 9 coverage; assets-pending column = where
// a real sample would replace the synth):
//
//   sfxHit              ally projectile hit                 short click
//   sfxKill             enemy destroyed                     low thump
//   sfxPickupDrop       pickup spawned                      rising chime
//   sfxPickupCollect    pickup collected by ally            chord up
//   sfxBreed            child born                          two-note rise
//   sfxBallDeath        ally dies                           descending pitch
//   sfxWaveEvent        wave event starts                   triadic chord
//   sfxRunEnd           run ends (game over)                low descending sweep

import { beep, chord, noiseBurst, sweep } from './synth';

export function sfxHit(ctx: AudioContext, out: AudioNode): void {
  beep(ctx, out, {
    freq: 880,
    duration: 0.02,
    attack: 0.001,
    release: 0.04,
    gain: 0.12,
    wave: 'square',
  });
}

export function sfxKill(ctx: AudioContext, out: AudioNode): void {
  noiseBurst(ctx, out, { duration: 0.12, lowpass: 600, gain: 0.18 });
  sweep(ctx, out, {
    fromFreq: 200,
    toFreq: 60,
    duration: 0.18,
    gain: 0.18,
    wave: 'triangle',
  });
}

export function sfxPickupDrop(ctx: AudioContext, out: AudioNode): void {
  sweep(ctx, out, {
    fromFreq: 440,
    toFreq: 880,
    duration: 0.14,
    gain: 0.18,
    wave: 'sine',
  });
}

export function sfxPickupCollect(ctx: AudioContext, out: AudioNode): void {
  chord(ctx, out, {
    freqs: [523.25, 659.25, 783.99], // C5 E5 G5
    duration: 0.18,
    gain: 0.3,
    wave: 'triangle',
  });
}

export function sfxBreed(ctx: AudioContext, out: AudioNode): void {
  const now = ctx.currentTime;
  beep(ctx, out, { freq: 659.25, duration: 0.1, gain: 0.22, wave: 'triangle' }, now);
  beep(ctx, out, { freq: 987.77, duration: 0.18, gain: 0.22, wave: 'triangle' }, now + 0.12);
}

export function sfxBallDeath(ctx: AudioContext, out: AudioNode): void {
  sweep(ctx, out, {
    fromFreq: 350,
    toFreq: 90,
    duration: 0.35,
    gain: 0.2,
    wave: 'sawtooth',
  });
}

export function sfxWaveEvent(ctx: AudioContext, out: AudioNode): void {
  chord(ctx, out, {
    freqs: [220, 277.18, 329.63], // A3 C#4 E4 (warning)
    duration: 0.45,
    gain: 0.28,
    wave: 'sawtooth',
  });
}

export function sfxRunEnd(ctx: AudioContext, out: AudioNode): void {
  const now = ctx.currentTime;
  noiseBurst(ctx, out, { duration: 0.6, lowpass: 400, gain: 0.18 }, now);
  sweep(ctx, out, {
    fromFreq: 220,
    toFreq: 55,
    duration: 0.9,
    gain: 0.22,
    wave: 'triangle',
  });
}
